import classNames from 'classnames';
import styles from './ProcessingIndicator.module.scss';

export default function ProcessingIndicator({
  customCss = '',
  theme = 'blue',
}) {
  return (
    <div
      className={classNames(
        'd-flex align-items-center justify-content-center text-center p-4 col-3',
        customCss,
        styles.indicator,
        {
          [styles.indicator_blue]: theme === 'blue',
          [styles.indicator_white]: theme === 'white',
        }
      )}
    >
      <span />
      <span />
      <span />
    </div>
  );
}
